import { render, staticRenderFns } from "./ToggleFullscreenButtonV2.vue?vue&type=template&id=481057d2&scoped=true&"
import script from "./ToggleFullscreenButtonV2.vue?vue&type=script&lang=js&"
export * from "./ToggleFullscreenButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./ToggleFullscreenButtonV2.vue?vue&type=style&index=0&id=481057d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481057d2",
  null
  
)

export default component.exports